/**
 * Telemetría local (stub): medidor de FPS y consola estructurada.
 * No envía datos a ningún servidor.
 */

type LogLevel = "debug" | "info" | "warn" | "error";

interface TelemetryEvent {
  level: LogLevel;
  scope: string;
  message: string;
  data?: Record<string, unknown>;
  timestamp: string;
}

export const telemetry = {
  log(level: LogLevel, scope: string, message: string, data?: Record<string, unknown>): void {
    const event: TelemetryEvent = {
      level,
      scope,
      message,
      timestamp: new Date().toISOString(),
      ...(data ? { data } : {}),
    };
    const line = `[cale-3d][${event.scope}] ${event.message}`;
    if (level === "error") console.error(line, event);
    else if (level === "warn") console.warn(line, event);
    else console.debug(line, event);
  },
  info(scope: string, message: string, data?: Record<string, unknown>): void {
    this.log("info", scope, message, data);
  },
  warn(scope: string, message: string, data?: Record<string, unknown>): void {
    this.log("warn", scope, message, data);
  },
  error(scope: string, message: string, data?: Record<string, unknown>): void {
    this.log("error", scope, message, data);
  },
};

export interface FpsSample {
  fps: number;
  frameMs: number;
}

/**
 * Medidor de FPS simple: acumula frames y reporta promedio por segundo.
 */
export class FpsMeter {
  private frames = 0;
  private lastMark = performance.now();
  private listener: ((sample: FpsSample) => void) | null = null;

  onSample(listener: (sample: FpsSample) => void): void {
    this.listener = listener;
  }

  tick(): void {
    this.frames += 1;
    const now = performance.now();
    const elapsed = now - this.lastMark;
    if (elapsed >= 1000) {
      const fps = (this.frames * 1000) / elapsed;
      this.listener?.({ fps: Math.round(fps), frameMs: Math.round((elapsed / this.frames) * 10) / 10 });
      this.frames = 0;
      this.lastMark = now;
    }
  }
}
